import { Drawer, DrawerTitle } from '@rocketlane/ui';
import { FC, useMemo } from 'react';
import { FormattedMessage } from 'react-intl';
import { AddFiles, AddFilesPayload } from './add-files';

interface Props {
  open: boolean;
  folderName: string;
  onClose: () => void;
  onDone: (payload: AddFilesPayload) => Promise<void>;
}
export const AddFilesDrawer: FC<Props> = ({
  open,
  onClose,
  onDone,
  folderName,
}) => {
  const breadcrumbs = useMemo(() => {
    return [
      {
        title: folderName,
        link: '',
      },
    ];
  }, [folderName]);

  return (
    <Drawer size="672px" placement="right" open={open} onClose={onClose}>
      <DrawerTitle className="sr-only">
        <FormattedMessage id="knowledge_base.add_files.title" />
      </DrawerTitle>
      <AddFiles onClose={onClose} onDone={onDone} breadcrumbs={breadcrumbs} />
    </Drawer>
  );
};
